import { Dimensions, Platform } from 'react-native';
import Theme from '@qnpm/q-theme';
import { isMiniScreen } from '../utils/constant';
// 左右边距
const PADDING_HORIZONTAL = 10;
// 日期间的间隔
const DAY_ITEM_SPACE = 3;
const isIOS = Platform.OS === 'ios';
const { font, layout } = Theme;
const { calendar } = layout;
export { PADDING_HORIZONTAL, DAY_ITEM_SPACE };
export default class Style {
    constructor(needScale) {
        this.computedLayout = needScale ? calendar.scaled : calendar.unscaled;
        this.computedFontSize = needScale
            ? font.size.scaled
            : font.size.unscaled;
        this.computedLineHeight = needScale
            ? font.lineHeight.scaled
            : font.lineHeight.unscaled;
    }
    get weekHeader() {
        return {
            wrapper: {
                paddingHorizontal: this.computedLayout.wrapper
                    .paddingHorizontal,
                height: this.computedLayout.weekHeader.height
            },
            weekItem: {
                width: (Dimensions.get('window').width -
                    PADDING_HORIZONTAL * 2 -
                    DAY_ITEM_SPACE * 6) /
                    7
            },
            text: {
                fontSize: this.computedFontSize.fontSizeM,
                lineHeight: this.computedLineHeight.lineHeightT14
            }
        };
    }
    get monthHeader() {
        return {
            wrapper: {
                paddingHorizontal: this.computedLayout.monthHeader
                    .paddingHorizontal,
                height: this.computedLayout.monthHeader.height
            },
            title: {
                fontSize: this.computedFontSize.fontSizeL,
                lineHeight: this.computedLineHeight.lineHeightT16
            },
            subTitle: {
                fontSize: this.computedFontSize.fontSizeS,
                lineHeight: this.computedLineHeight.lineHeightT12
            },
            line: this.computedLayout.monthHeaderLine,
            oprImage: this.computedLayout.monthHeaderOprImage,
            oprText: {
                fontSize: this.computedFontSize.fontSizeM,
                lineHeight: this.computedLineHeight.lineHeightT14
            },
            oprArrow: this.computedLayout.monthHeaderOprArrow,
            oprBgImage: this.computedLayout.monthHeaderOprBgImage
        };
    }
    get toolTip() {
        return {
            wrapper: {
                paddingHorizontal: this.computedLayout.toolTip
                    .paddingHorizontal,
                paddingVertical: this.computedLayout.toolTip.paddingVertical,
                borderRadius: this.computedLayout.toolTip.borderRadius
            },
            text: {
                fontSize: this.computedFontSize.fontSizeM,
                lineHeight: this.computedLineHeight.lineHeightT14
            },
            arrow: {
                bottom: -(this.computedLayout.toolTip.arrowWidth +
                    this.computedLayout.toolTip.arrowHeight) + (isIOS ? 0 : 0.5),
                borderTopWidth: this.computedLayout.toolTip.arrowWidth,
                borderRightWidth: this.computedLayout.toolTip.arrowWidth,
                borderLeftWidth: this.computedLayout.toolTip.arrowWidth,
                borderBottomWidth: this.computedLayout.toolTip.arrowHeight
            },
            centerArrow: {
                marginLeft: this.computedLayout.toolTip.arrowWidth +
                    this.computedLayout.toolTip.arrowHeight -
                    1
            },
            leftArrow: {
                left: (Dimensions.get('window').width -
                    PADDING_HORIZONTAL * 2 -
                    DAY_ITEM_SPACE * 6) /
                    7 /
                    2,
                marginLeft: -this.computedLayout.toolTip.arrowWidth
            },
            rightArrow: {
                right: (Dimensions.get('window').width -
                    PADDING_HORIZONTAL * 2 -
                    DAY_ITEM_SPACE * 6) /
                    7 /
                    2,
                marginRight: -this.computedLayout.toolTip.arrowWidth
            }
        };
    }
    get monthContent() {
        return {
            wrapper: {
                paddingTop: this.computedLayout.monthHeader.marginBottom,
                paddingBottom: this.computedLayout.monthHeader.marginTop
            },
            underText: {
                fontSize: this.computedLayout.monthUnderText.size
            }
        };
    }
    get dayList() {
        return {
            row: {
                marginBottom: this.computedLayout.dayRow.bottom
            }
        };
    }
    get dayItem() {
        return {
            container: {
                width: (Dimensions.get('window').width -
                    PADDING_HORIZONTAL * 2 -
                    DAY_ITEM_SPACE * 6) /
                    7,
                height: this.computedLayout.dayItem.height,
                padding: this.computedLayout.dayItem.padding
            },
            spaceView: {
                width: this.computedLayout.dayItem.space,
                height: this.computedLayout.dayItem.height
            },
            linearGradient: {
                borderRadius: this.computedLayout.dayItem.radius
            },
            headerContainer: {
                top: this.computedLayout.dayItem.padding
            },
            headerAfterArrow: {
                right: isMiniScreen
                    ? -2
                    : this.computedLayout.dayItem.arrowDistance
            },
            headerBeforeArrow: {
                left: isMiniScreen
                    ? -2
                    : this.computedLayout.dayItem.arrowDistance
            },
            headerText: {
                fontSize: this.computedFontSize.fontSizeXS,
                lineHeight: this.computedLineHeight.lineHeightT10
            },
            contentText: {
                fontSize: this.computedFontSize.fontSizeL,
                lineHeight: this.computedLineHeight.lineHeightT16
            },
            contentSmallText: {
                fontSize: this.computedFontSize.fontSizeM,
                lineHeight: this.computedLineHeight.lineHeightT14,
                fontWeight: 'bold'
            },
            footerText: {
                fontSize: isMiniScreen ? 7 : this.computedFontSize.fontSizeXS,
                lineHeight: isMiniScreen
                    ? 11
                    : this.computedLineHeight.lineHeightT10,
                bottom: this.computedLayout.dayItem.padding
            },
            footerImage: Object.assign({ bottom: this.computedLayout.dayItem.padding, right: this.computedLayout.dayItem.padding }, this.computedLayout.dayImage)
        };
    }
}
